import { Component } from '@angular/core';
import { TicketType } from 'wms-lib';
import { CatalogComponent } from '../../base-components/catalog.component';

@Component({
  selector: 'app-ticket-types',
  templateUrl: './ticket-types.component.html',
  styleUrls: ['./ticket-types.component.sass']
})
export class TicketTypesComponent extends CatalogComponent<TicketType> {
  name_catalog = 'ticket_types';
  title = 'Ticket Types';
  workingItem: TicketType;

  addNew(_type?: string) {
    let c = this.newItem({ name_es: '', name_en: '', type: _type });
    this.items[c.id] = c;
    this.items = { ...this.items };
  }

  newItem(data: any) {
    return new TicketType(data);
  }

  setWorkingItem(item: TicketType, op, event) {
    this.workingItem = item;
    op.toggle(event);
  }

  editCloseMessage(item: TicketType, op, event) {
    if (!item.config) {
      item.config = {};
    }
    this.setWorkingItem(item, op, event);
  }


  deleteRestriction(index: number) {
    this.notificationService.showFeedback(
      'Are you sure you want to delete this file restriction?',
      'Confirm',
      false,
      null,
      () => this.workingItem.config.file_restrictions.splice(index, 1)
    );
  }

  addNewRestriction() {
    if (!this.workingItem.config) {
      this.workingItem.config = {};
    }

    if (!this.workingItem.config.file_restrictions) {
      this.workingItem.config.file_restrictions = [];
    }

    const newRestriction = {
      file_types: ['pdf'],
      quantity_range: '1..1',
      quantity_range_start: 1,
      quantity_range_end: 1
    };

    this.workingItem.config.file_restrictions.push(newRestriction);
  }


  rangeDescription(rangeStr): string {
    const start = rangeStr.split('..')[0];
    const end = rangeStr.split('..')[1];

    if (start && end) {
      if (start === end) {
        return `exactly ${start} file(s)`;
      } else if (start === '0') {
        return `up to ${end} file(s)`;
      } else {
        return `between ${start} and ${end} files`;
      }
    } else if (start && !end) {
      return `${start} or more files`;
    } else if (!start && end) {
      return `up to ${end} files`;
    } else {
      return `any number of files`;
    }
  }


  updateQuantityRange(restriction: any) {
    let start = restriction.quantity_range_start;
    let end = restriction.quantity_range_end;

    if (end <= start) {
      restriction.quantity_range_end = start;
      end = start;
    }

    if (start == 0 && end == 0) {
      restriction.quantity_range_end = 1;
      end = 1;
    }

    restriction.quantity_range = `${start}..${end}`;
  }

}
